<script lang="ts">
    import Dummy from '../../../shared/Dummy.svelte';
    import Duration from '../../../shared/Duration.svelte';
    import Distance from '../../../shared/Distance.svelte';
    import { RouteInfoUtils } from '../PageDeliveries2/RouteSummaryApp/RouteInfoUtils';
    import RouteCost from './RouteCost.svelte';

    export let distanceMeters: number | null = null;
    export let durationSeconds: number | null = null;
    export let routeCost: number | null = null;
    export let routeCostDetails: Record<string,(number|null)[]> | null = null;
    export let color: string | null = null;

    let routeDataWrapper = Dummy;
</script>

<svelte:component this={routeDataWrapper}>
    <div class="route_info_inner" style="color: {color ? color : 'inherit'};">
        <div class="distance">
            {#if distanceMeters}
                <Distance meters={distanceMeters} flexDirection="column" bold={false} />
            {:else}
                ---
            {/if}
        </div>
        <div class="vertical-separator">|</div>
        <div class="duration">
            {#if durationSeconds}
                <Duration
                    seconds={durationSeconds}
                    showExclamation={false}
                    flexDirection="column"
                    displayFormat="time"
                    bold={false}
                />
            {:else}
                ---
            {/if}
        </div>
        <div class="vertical-separator">|</div>
        <div class="route-cost">
            {#if routeCost}
                <RouteCost cost={routeCost} currency={RouteInfoUtils.getCurrency()} details={routeCostDetails} tooltipPosition="bottom"/>
            {:else}
                ---
            {/if}
        </div>
    </div>
</svelte:component>

<style>
    .route_info_inner {
        display: flex;
        justify-content: center;
        /*width: 100%;*/
        font-size: 12px;
        align-items: center;
        margin-bottom: -1px;
    }

    .route_info_inner .distance {
        display: flex;
        flex: 1 1 40%;
        justify-content: center;
        padding: 0 2px;
    }

    .route_info_inner .duration {
        display: flex;
        flex: 1 0 20%;
        justify-content: center;
        padding: 0 2px;
    }

    .route_info_inner .route-cost {
        display: flex;
        flex: 1 1 40%;
        justify-content: center;
        padding: 0 2px;
    }

    .vertical-separator {
        font-weight: 200;
        margin: 0 3px;
        opacity: 0.3;
    }
</style>
